(function () {
  // ── Core API ──────────────────────────────────────────────────────────────

  function openRebuyCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.status === 'ready') {
      window.Rebuy.SmartCart.show();
      return true;
    }
    return false;
  }

  // ── Loading backdrop ──────────────────────────────────────────────────────
  // Shown only when Rebuy is not yet ready (> 150 ms wait). Removed as soon
  // as Rebuy opens or the 10 s timeout is reached.

  var _loaderTimer = null;

  function showLoader() {
    if (document.getElementById('rebuy-loader')) return;

    var style = document.createElement('style');
    style.id = 'rebuy-loader-style';
    style.textContent =
      '#rebuy-loader{position:fixed;inset:0;z-index:99998;background:rgba(0,0,0,.45);' +
      'display:flex;align-items:center;justify-content:center;}' +
      '#rebuy-loader-spinner{width:44px;height:44px;border-radius:50%;' +
      'border:3px solid rgba(255,255,255,.25);border-top-color:#fff;' +
      'animation:rebuy-spin .7s linear infinite;}' +
      '@keyframes rebuy-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);

    var el = document.createElement('div');
    el.id = 'rebuy-loader';
    el.innerHTML = '<div id="rebuy-loader-spinner"></div>';
    document.body.appendChild(el);
  }

  function hideLoader() {
    clearTimeout(_loaderTimer);
    var el    = document.getElementById('rebuy-loader');
    var style = document.getElementById('rebuy-loader-style');
    if (el)    el.parentNode.removeChild(el);
    if (style) style.parentNode.removeChild(style);
  }

  // ── Opens Rebuy as soon as the Smart Cart is ready ────────────────────────
  // Tries immediately, listens for rebuy:smartcart.ready on document + window,
  // and polls every 50 ms for up to 10 s as a final fallback.
  function openWhenReady() {
    if (openRebuyCart()) return;

    // Only show the backdrop after 150 ms so fast loads never flash it.
    _loaderTimer = setTimeout(showLoader, 150);

    var done = false;

    function tryOpen() {
      if (done) return;
      if (openRebuyCart()) {
        done = true;
        hideLoader();
        clearInterval(poll);
        document.removeEventListener('rebuy:smartcart.ready', tryOpen);
        window.removeEventListener('rebuy:smartcart.ready', tryOpen);
      }
    }

    document.addEventListener('rebuy:smartcart.ready', tryOpen, { once: true });
    window.addEventListener('rebuy:smartcart.ready', tryOpen, { once: true });

    var attempts = 0;
    var poll = setInterval(function () {
      tryOpen();
      if (done || ++attempts >= 600) { hideLoader(); clearInterval(poll); } // 30 s max
    }, 50);
  }

  // Exposed so cart-notification.js can call it after add-to-cart.
  window.openRebuyCart = openWhenReady;

  // ── Fetch interceptor ─────────────────────────────────────────────────────
  // Watches every fetch() call. When a successful POST to /cart/add(.js) is
  // detected — from any source (Replo, Kaching Bundle, theme, etc.) — Rebuy
  // is opened automatically. response.ok is checked so errors (e.g. out-of-
  // stock 422s) never trigger the drawer. The response body is never consumed
  // so the original caller's .json() / .text() still works normally.
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    var promise = _origFetch.apply(this, arguments);
    try {
      var u = new URL(url, window.location.origin);
      if (u.host === window.location.host && /\/cart\/add/.test(u.pathname)) {
        promise.then(function (response) {
          if (response.ok) openWhenReady();
        }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };

  // ── 1. Intercept every /cart link click ───────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    try {
      var url = new URL(link.href, window.location.origin);
      if (url.host === window.location.host && url.pathname === '/cart') {
        e.preventDefault();
        openWhenReady();
      }
    } catch (err) {}
  });

  // ── 2. ?viewcart=true ─────────────────────────────────────────────────────
  // Handles the /cart page redirect and any external ?viewcart=true links.
  if (new URLSearchParams(window.location.search).get('viewcart') === 'true') {
    var cleanUrl = window.location.pathname +
      window.location.search.replace(/[?&]viewcart=true/, '').replace(/^&/, '?') +
      window.location.hash;
    history.replaceState(null, '', cleanUrl || window.location.pathname);
    openWhenReady();
  }
})();
